import { Component, Input, input, ChangeDetectionStrategy, inject } from '@angular/core';
import { BatchValidation } from '../../interfaces/batch-validations/batch-validation';
import { SlideDownAnimation } from '../animations';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'lib-batch-validations',
    templateUrl: './batch-validations.component.html',
    styleUrl: './batch-validations.component.css',
    animations: [
        SlideDownAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BatchValidationsComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() attachmentErrors!: BatchValidation[];
  @Input() headerErrors!: BatchValidation[];
  @Input() dataErrors!: BatchValidation[];
  @Input() collapsible = true;

  protected expandAttachment = true;
  protected expandHeaders = true;
  protected expandData = false;

  getMessage(validation: BatchValidation): string {
    var clientMessage = validation.message;
    
    if (validation.field) {
      clientMessage = this.transloco.translate('batchValidations.columnMessage', { column: validation.field, message: clientMessage })
    }
    else if (validation.column) {
      clientMessage = this.transloco.translate('batchValidations.columnMessage', { column: validation.column, message: clientMessage })
    }

    if (validation.row) {
      clientMessage = this.transloco.translate('batchValidations.rowMessage', { row: validation.row, message: clientMessage })
    }

    if (validation.data) {
      clientMessage = this.transloco.translate('batchValidations.currentValueMessage', { message: clientMessage, value: validation.data })
    }

    return clientMessage;
  }

  showAttachmentErrors() {
    return this.attachmentErrors.length > 0;
  }

  shouldShowAttachmentErrors() {
    if (this.collapsible) {
      return this.expandAttachment;
    } else {
      return this.showAttachmentErrors();
    }
  }

  showHeaderErrors() {
    return this.headerErrors.length > 0;
  }

  shouldShowHeaderErrors() {
    if (this.collapsible) {
      return this.expandHeaders;
    } else {
      return this.showHeaderErrors();
    }
  }

  showDataErrors() {
    return this.dataErrors.length > 0;
  }

  shouldShowDataErrors() {
    if (this.collapsible) {
      return this.expandData;
    } else {
      return this.showDataErrors();
    }
  }
}
